import { Typography } from "@mui/material";
import React from "react";
import { Box } from "@mui/system";
import { Link } from "react-router-dom";
import { UserCommonStyles } from "../../styles/CommonStyles";
import { HeaderStyles } from "../../styles/Header";

import Logo from "../../images/logo-petlover.png";

const CSAEPolicy: React.FC = () => {
  const commonStyle = UserCommonStyles();
  const styleClasses = HeaderStyles();

  return (
    <div className={commonStyle.p20}>
      <Box className={`${commonStyle.mb20} ${styleClasses.logo}`}>
        <Link to="/">
          <img src={Logo} alt="logo" />
        </Link>
      </Box>

      <Typography variant="h5">Prohibition of Child Sexual Abuse and Exploitation (CSAE)</Typography>

      <Typography variant="h5">Zero Tolerance Policy</Typography>
      <p>
        PetLoversChat has a zero-tolerance policy toward Child Sexual Abuse and Exploitation (CSAE). "CSAE" refers to any activity involving the abuse or exploitation of minors, including the
        production, distribution, or possession of child sexual abuse material (CSAM). Any content, actions, or communications that involve or promote CSAE or CSAM in any form are strictly prohibited
        on this platform.
      </p>

      <Typography variant="h5">Prohibited Conduct</Typography>
      <p>Users must not engage in, solicit, produce, distribute, or facilitate CSAE. This includes, but is not limited to:</p>
      <ul>
        <li>Any form of child pornography as defined by 18 U.S.C. § 2256.</li>
        <li>Any content that sexualizes minors or solicits personal information from minors.</li>
        <li>Activities or communications that victimize, exploit, or intimidate minors.</li>
      </ul>

      <Typography variant="h5">Reporting and Enforcement</Typography>
      <p>PetLoversChat provides in-app reporting mechanisms so users can report suspected violations. We encourage users to report any content or behavior they believe may involve CSAE.</p>
      <p>All reports are handled confidentially and reviewed promptly. Confirmed violations may result in:</p>
      <ul>
        <li>Immediate removal of the content.</li>
        <li>Account suspension or permanent ban.</li>
        <li>Reporting to the National Center for Missing & Exploited Children (NCMEC) and other relevant law enforcement agencies as required by law.</li>
      </ul>

      <Typography variant="h5">Legal Compliance</Typography>
      <p>
        PetLoversChat complies with all applicable child protection laws, including the PROTECT Act (18 U.S.C. § 2258A). We are legally obligated to report detected CSAM to NCMEC and cooperate with
        law enforcement in investigations. Users are reminded that generating, sharing, or promoting CSAE material is a serious crime and carries severe penalties.
      </p>

      <Typography variant="h5">Reasonable Measures & Limitation of Liability</Typography>
      <p>
        PetLoversChat employs reasonable technical, organizational, and procedural measures to detect and address CSAE. While these measures significantly reduce risks, no system can guarantee
        complete prevention or removal of abusive content.
      </p>
      <p>
        Users remain solely responsible for the content they upload, share, or transmit. PetLoversChat disclaims liability for user-generated content but commits to taking immediate, appropriate
        action when violations are detected or reported.
      </p>

      <Typography variant="h5">Account Termination</Typography>
      <p>PetLoversChat reserves the right to suspend or terminate access to any user account that violates this policy or related Terms of Service, without prior notice.</p>

      <Typography variant="h5">Commitment to Safety</Typography>
      <p>By using PetLoversChat, you affirm your commitment to this policy and to helping us maintain a safe environment for all users.</p>

      <Typography variant="h5">Contact Us</Typography>
      <p>If you have questions about our CSAE Policy or need to report suspected violations, contact us by:</p>
      <ul>
        <li>E-mail: info@petloverschat.com</li>
      </ul>
    </div>
  );
};

export default CSAEPolicy;
